export enum ApiUrl {
    // Authentication
    LOGIN = '/user/login',
    LOGIN_CLIENT = '/user/login/client', 
    REFRESH = '/user/refresh',
    LOGOUT = '/user/logout',

    // Dashboard
    GET_DASHBOARD_STATS = '/dashboard/stats',

    //user
    POST_USER_SEARCH = "/user/search",
    GET_USER = "/user/:id",
    POST_ADD_USER = "/user",
    PUT_EDIT_USER = "/user/:id",
    DELETE_USER = "/user/:id",

    // Terminal
    GET_TERMINAL_AVAILABLE = "/terminal/available",
    GET_MY_TERMINALS = "/terminal/my",
    GET_TERMINAL_RANKING = "/terminal/ranking",
    POST_TERMINAL_ASSOCIATE = "/terminal/associate", 
    DELETE_TERMINAL = "/terminal/:id",
    GET_CASINO_STATS = "/terminal/:id/casino-stats",
    GET_GLOBAL_STATS = "/terminal/:id/global-stats",
    PUT_TERMINAL = "/terminal/:id",
    DELETE_TERMINAL_COMMERCIAL = "/terminal/:id/commercial",
    REPLACE_TERMINAL = "/terminal/:id/replace",

    // National Average
    GET_NATIONAL_AVERAGES = "/national-average",
    GET_NATIONAL_AVERAGE = "/national-average/:year",
    POST_NATIONAL_AVERAGE = "/national-average",
    DELETE_NATIONAL_AVERAGE = "/national-average/:year",

    // Cron Logs
    GET_CRON_LOGS = "/cron-logs",

}
